import axiosInstance from "./axiosInstance";

const packingService = {
  create: async (payload) => {
    try {
      const response = await axiosInstance.post("/packingProducts/create", payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getAll: async () => {
    try {
      const response = await axiosInstance.get("/packingProducts/all");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  fetchAllDetails: async () => {
    try {
      const response = await axiosInstance.get("/packingProducts/alldetails");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getSingle: async (id) => {
    try {
      const response = await axiosInstance.get(`/packingProducts/single/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ✅ Keep only this one
  place: async (packingId, payload) => {
    try {
      const response = await axiosInstance.put(
        `/packingProducts/place/${packingId}`,
        payload
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default packingService;
